<template>
  <div id="Dashboard">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>Dashboard</span>
            </h1>
            <div class="page-header-subtitle">Support Ticketing Reports</div>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <div class="card-header">
                <div class="mr-5">{{ periodLabel }} reports</div>
                <select @change="selectPeriod($event)" class="form-control mr-2" style="width: 200px">
                  <option value>Reports period ...</option>
                  <option value="today">Today</option>
                  <option value="week">This week</option>
                  <option value="month">This month</option>
                  <option value="year">This year</option>
                  <!--  <option value="range">Date Range</option> -->
                </select>
                <!-- <date-range-picker v-model="dateRange" :time-picker="false" :locale-data="{ firstDay: 0, format: 'YYYY-MM-DD' }">
                  <template v-slot:input="picker" style="min-width: 350px;">{{ picker.startDate | date }} - {{ picker.endDate | date }}</template>
                </date-range-picker>-->
                <date-range-picker v-model="dateRange" :date-format="dateFormat" @update="updateValues"></date-range-picker>
              </div>
              <div class="card-body">
                <highcharts :options="chartOptions"></highcharts>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-3 col-md-6">
            <div class="card bg-primary text-white mb-4">
              <div class="card-body">
                Raised
                <span class="periodLabel">{{ periodLabel }}</span>
                <h1 class="mt-2 mb-2 text-white" v-show="infoBox.raised > 0">{{ infoBox.raised | thousandSeparator }}</h1>
                <h1 class="mt-2 mb-2 text-white" v-show="infoBox.raised < 1">0</h1>
              </div>
              <div class="card-footer d-flex align-items-center justify-content-between">
                <router-link to="/admin/tickets/all" class="small text-white stretched-link">View Details</router-link>
                <div class="small text-white">
                  <i class="fas fa-angle-right"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="card bg-danger text-white mb-4">
              <div class="card-body">
                Open
                <span class="periodLabel">{{ periodLabel }}</span>
                <h1 class="mt-2 mb-2 text-white" v-show="infoBox.open > 0">{{ infoBox.open | thousandSeparator }}</h1>
                <h1 class="mt-2 mb-2 text-white" v-show="infoBox.open < 1">0</h1>
              </div>
              <div class="card-footer d-flex align-items-center justify-content-between">
                <router-link to="/admin/tickets/open" class="small text-white stretched-link">View Details</router-link>
                <div class="small text-white">
                  <i class="fas fa-angle-right"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="card bg-warning text-white mb-4">
              <div class="card-body">
                Escalated
                <span class="periodLabel">{{ periodLabel }}</span>
                <h1 class="mt-2 mb-2 text-white" v-show="infoBox.escalated > 0">{{ infoBox.escalated | thousandSeparator }}</h1>
                <h1 class="mt-2 mb-2 text-white" v-show="infoBox.escalated < 1">0</h1>
              </div>
              <div class="card-footer d-flex align-items-center justify-content-between">
                <router-link to="/admin/tickets/escalated" class="small text-white stretched-link">View Details</router-link>
                <div class="small text-white">
                  <i class="fas fa-angle-right"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="card bg-success text-white mb-4">
              <div class="card-body">
                Closed
                <span class="periodLabel">{{ periodLabel }}</span>
                <h1 class="mt-2 mb-2 text-white" v-show="infoBox.closed > 0">{{ infoBox.closed | thousandSeparator }}</h1>
                <h1 class="mt-2 mb-2 text-white" v-show="infoBox.closed < 1">0</h1>
              </div>
              <div class="card-footer d-flex align-items-center justify-content-between">
                <router-link to="/admin/tickets/closed" class="small text-white stretched-link">View Details</router-link>
                <div class="small text-white">
                  <i class="fas fa-angle-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card mb-4">
          <div class="card-header">{{ periodLabel }} {{ client.topCategoryLabel }} reports table</div>
          <div class="card-body">
            <vue-good-table
              :columns="columns"
              :rows="categoriesStat"
              :search-options="{
                enabled: true,
                trigger: 'enter',
              }"
              :pagination-options="{
                enabled: true,
                perPage: 20,
              }"
            />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import { Chart } from "highcharts-vue";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  name: "Dashboard",
  data() {
    let startDate = new Date();
    let endDate = new Date();
    startDate.setDate(endDate.getDate() - 60);
    //endDate.setDate(endDate.getDate() - 30);
    return {
      infoBox: {},
      periodLabel: "",
      categoriesStat: [],
      dateRange: { startDate, endDate },
      /* dfdfs */
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Raised",
          field: "raised",
          type: "number",
        },
        {
          label: "Open",
          field: "opened",
          type: "number",
        },
        {
          label: "Escalated",
          field: "escalated",
          type: "number",
        },
        {
          label: "Closed",
          field: "closed",
          type: "number",
        },
      ],

      /* dfdfs */
    };
  },

  filters: {
    date(val) {
      return val ? val.toLocaleString() : "";
    },
  },

  components: {
    highcharts: Chart,
    DateRangePicker,
  },

  mounted() {
    this.getReports("year");
  },

  methods: {
    selectPeriod(e) {
      if (e.target.value !== "range") {
        this.getReports(e.target.value);
      }
    },

    getReports(period, start = "", end = "") {
      //console.log("What I get (DASHBOARD): " + this.$store.state.authToken);
      let loading = this.$loading.show();
      axios.get(`/admin/dashboard?q=${period}&start=${start}&end=${end}`).then((res) => {
        this.infoBox = res.data.infoBox;
        this.periodLabel = res.data.periodLabel;
        this.categoriesStat = res.data.categoriesStat;
        loading.hide();
      });
    },

    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() > new Date();
      }
      return classes;
    },

    updateValues(v) {
      let startDate = `${v.startDate.getFullYear()}-${v.startDate.getMonth() + 1}-${v.startDate.getDate()}`;
      let endDate = `${v.endDate.getFullYear()}-${v.endDate.getMonth() + 1}-${v.endDate.getDate()}`;
      this.getReports("range", startDate, endDate);
    },
  },

  computed: {
    client() {
      return this.$store.state.client;
    },

    chartOptions() {
      let names = [];
      let raised = [];
      let open = [];
      let escalated = [];
      let closed = [];

      for (let index = 0; index < this.categoriesStat.length; index++) {
        names.push(this.categoriesStat[index].name);
        raised.push(this.categoriesStat[index].raised);
        open.push(this.categoriesStat[index].opened);
        escalated.push(this.categoriesStat[index].escalated);
        closed.push(this.categoriesStat[index].closed);
      }

      return {
        chart: {
          //type: "spline",
          type: "column",
          //type: "area",
          //type: "line"
        },
        series: [
          /* {
            name: "Raised",
            data: raised,
            color: "#0061f2"
          }, */
          {
            name: "Open",
            data: open,
            color: "#e81500",
          },
          {
            name: "Escalated",
            data: escalated,
            color: "#f4a100",
          },
          {
            name: "Closed",
            data: closed,
            color: "#00ac69",
          },
        ],
        xAxis: {
          categories: names,
          crosshair: true,
        },
        yAxis: {
          title: {
            text: "Number of tickets",
          },
        },

        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },
        credits: {
          enabled: false,
        },
      };
    },
  },
};
</script>

<style scoped>
.periodLabel {
  font-size: 12px;
  color: #f9f9f9;
}
</style>